<template>
<div>
    <clients-form :getClientsList="getClientsList" ref="clientsFormModal"></clients-form>
    <add-new-law-client-form :getClientsList="getClientsList" ref="addNewLawClientFormModal"></add-new-law-client-form>
    <clients-reports-form ref="clientsReportsFormModal"></clients-reports-form>
    <b-row class="align-items-center">
        <b-col class="d-flex align-items-center col-lg-8">
            <div class="mr-1">
                <label for="client-name-input">{{ $t('others.search_name') }}</label>
                <b-form-input size="sm" v-model="name" v-on:keyup.enter="getClientsList()" :placeholder="$t('clients.name')" type="text" class="d-inline-block mb-2" />
            </div>

            <div class="mr-1">
                <label for="client-country-input">{{ $t('clients.country') }}</label>
                <b-form-select id="client-country-input" v-model="countrySelect" size="sm" value-field="id" text-field="name" :options="countryOption" class="mb-2" />
            </div>
        </b-col>
        <b-col class="d-flex justify-content-end col-lg-4">
            <b-button style="float:right;" class="mr-1" size="sm" variant="outline-primary" @click="getClientsList()" v-on:keyup.enter="getClientsList()">{{ $t('clients.list') }}</b-button>
            <b-button style="float:right;" class="mr-1" size="sm" variant="outline-primary" @click="addNewLawClient(0)">{{ $t('clients.add') }}</b-button>
            <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('lawyerDailyworkReport.excel') }}</b-button>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="clientTable" ref="clientTable" :columns="columns" :rows="rows" :sort-options="{enabled: false}" :search-options="{ enabled: true, externalQuery: searchTerm}" 
    styleClass="vgt-table condensed tableSize" :select-options="{enabled: false, selectOnCheckboxOnly: true, selectionInfoClass: 'custom-class', selectionText: 'rows selected', 
    clearSelectionText: 'clear', disableSelectInfo: true, selectAllByGroup: true}" :pagination-options="{ enabled: true, perPage: pageLength}" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Labels -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('clients.name') }}
            </span>
            <span v-else-if="props.column.field === 'clientAccountingList'">
                <b-row>
                    <b-col>
                        <span v-b-popover.hover.top="$t('clients.case')" style="cursor: pointer;">
                            {{ $t('clients.dv') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span v-b-popover.hover.top="$t('clients.consultancy')" style="cursor: pointer;">
                            {{ $t('clients.le') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span v-b-popover.hover.top="$t('clients.duty_registration')" style="cursor: pointer;">
                            {{ $t('clients.cu') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span v-b-popover.hover.top="$t('clients.stop_duty')" style="cursor: pointer;">
                            {{ $t('clients.sc') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span v-b-popover.hover.top="$t('clients.detection_of_evidence')" style="cursor: pointer;">
                            {{ $t('clients.dt') }}
                        </span>
                    </b-col>
                    <b-col v-b-popover.hover.top="$t('clients.smuggling')" style="cursor: pointer;">
                        <span>
                            {{ $t('clients.as') }}
                        </span>
                    </b-col>
                    <b-col v-b-popover.hover.top="$t('clients.legal_notice')" style="cursor: pointer;">
                        <span>
                            {{ $t('clients.ln') }}
                        </span>
                    </b-col>
                     <b-col v-b-popover.hover.top="$t('clients.simplified_destruction')" style="cursor: pointer;">
                        <span>
                            {{ $t('clients.sd') }}
                        </span>
                    </b-col>
                     <b-col v-b-popover.hover.top="$t('clients.mediation')" style="cursor: pointer;">
                        <span>
                            {{ $t('clients.ar') }}
                        </span>
                    </b-col>
                    
                </b-row>
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Elements -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Client Name -->
            <span v-if="props.column.field === 'client'">
                <b-col>
                    <b-row>
                        <span style="font-size: smaller"><b>{{ props.row.client }}</b></span>
                    </b-row>
                    <b-row v-if="props.row.clientAddress !== null">
                        <span>
                            <tr v-if="clientAddress.address !== null" style="font-size: smaller">{{ props.row.clientAddress.address}}
                            </tr>
                            <tr v-if="clientAddress.country !== null" style="font-size: smaller">{{ props.row.clientAddress.country}}
                            </tr>
                        </span>
                    </b-row>
                </b-col>
            </span>
            <!-- Column: Accounting -->
            <span style="text-align: right" v-else-if="props.column.field === 'accounting'">
                <b-col>
                    <b-row v-for="clientAccounting in props.row.clientAccountingList" v-bind:key="clientAccounting.number"   v-b-popover.hover="getPopoverConfig(clientAccounting)">
                        <label> <b-badge style="color:black;; background-color:#e0e0e0;" pill>{{clientAccounting.number + ' ' +  clientAccounting.code}} </b-badge></label>
                    </b-row>
                </b-col>
            </span>
            <!-- Column: AccountingList -->
            <span v-else-if="props.column.field === 'clientAccountingList'">
                <b-row v-for="clientAccounting in props.row.clientAccountingList" v-bind:key="clientAccounting.code">
                    <b-col class="col-12">
                        <b-row>
                            <b-col>
                                <span :style="[ clientAccounting.countOfDV > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 1, clientAccounting.id)">{{ clientAccounting.countOfDV }}</span>
                            </b-col>
                            <b-col>
                                <span :style="[ clientAccounting.countOfLE > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 2, clientAccounting.id)">{{ clientAccounting.countOfLE }}</span>
                            </b-col>
                            <b-col>
                                <span :style="[ clientAccounting.countOfCU > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 3, clientAccounting.id)">{{ clientAccounting.countOfCU }}</span>
                            </b-col>
                            <b-col>
                                <span :style="[ clientAccounting.countOfSC > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 4, clientAccounting.id)">{{ clientAccounting.countOfSC }}</span>
                            </b-col>
                            <b-col>
                                <span :style="[ clientAccounting.countOfDT > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 5, clientAccounting.id)">{{ clientAccounting.countOfDT }}</span>
                            </b-col>
                            <b-col>
                                <span :style="[ clientAccounting.countOfAS > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 7, clientAccounting.id)">{{ clientAccounting.countOfAS }}</span>
                            </b-col>
                             <b-col>
                                <span :style="[ clientAccounting.countOfLN > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 8, clientAccounting.id)">{{ clientAccounting.countOfLN }}</span>
                            </b-col>
                             <b-col>
                                <span :style="[ clientAccounting.countOfSD > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 9, clientAccounting.id)">{{ clientAccounting.countOfSD }}</span>
                            </b-col>
                            <b-col>
                                <span :style="[ clientAccounting.countOfAR > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 10, clientAccounting.id)">{{ clientAccounting.countOfAR}}</span>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </span>
            <!-- Column: Process -->
            <span v-else-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id,props.row.clientId)">

                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                        <feather-icon icon="XIcon" />
                    </b-button>
                </span>
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}
                    </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getClientsList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            countrySelect: 0,
            countryOption: [],
            total: 0,
            pageLength: 10,
            pageNo: 1,
            dir: false,
            clientAddress: '',
            columns: [
                {
                    label: this.$t('clients.name'),
                    field: `client`,
                },
                {
                    label: this.$t('clients.accounting'),
                    field: `accounting`,
                },
                {
                    field: `clientAccountingList`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
            agentOwnerSelect: 0
        }
    },
    mounted() {
        this.getClientsList()
    },
    methods: {
        getPopoverConfig(clientAccounting) {
            const forInvoice = clientAccounting && clientAccounting.forInvoice === true ? this.$t("others.yes") : this.$t("others.no");
            const forAgent = clientAccounting && clientAccounting.forAgent === true ? this.$t("others.yes") : this.$t("others.no");
            const combinedTitle = '';
            const combinedContent = `<strong>${this.$t("others.for_agent")}: </strong> ${forAgent}<br/><strong>${this.$t("others.for_invoice")}: </strong> ${forInvoice}`;

            return {
                title: combinedTitle,
                content: combinedContent,
                html: true,
                placement: 'left',
                customClass: 'small-popover'
            };
        },
        showDetailList(clientType, lawMatterTypeId, id) {

            if(id != 0){
                this.$refs.clientsReportsFormModal.showInfo(clientType, lawMatterTypeId, id)
            } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getClientsList()
            }
        },
        async deleted(data) {
            data = { id: data.id}
            const controller = { name: 'LawClient'}
            const payload = { data: data, controller: controller}
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getClientsList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getClientsList()
                        }
                    })
                }
            })
        },
        async getInfo(id,clientId) {
            this.$refs.clientsFormModal.showInfo(id,clientId)
        },
        addNewLawClient() {
            this.$refs.addNewLawClientFormModal.showInfo(true)
        },
        getClientsList() {
            this.rows = []
            const controller = { name: 'LawClient'}
            const data = { clientName: this.name,  pageLength: this.pageLength, pageNo: this.pageNo, isAgent: true, countryId: this.countrySelect}
            const payload = { data: data, controller: controller}
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.total = response.data.total
                    this.countrySelect = this.countrySelect
                    this.countryOption = response.data.countryList
                    this.countryOption.splice(0, 0, this.$nullSelected())

                    response.data.lawClientList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportExcel() {
            const controller = { name: 'LawClient', actionName: 'CanExport'}
            const data = { columnList: this.columns, DataList: this.rows}
            const payload = { data: data, controller: controller }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Clients", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

[dir] .dark-layout .card {
    background-color: #252d3f !important;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 24%) !important;
}

.custom-checkbox .custom-control-label,
.custom-radio .custom-control-label {
    font-size: 1rem;
    position: static;
    inline-size: max-content !important;
}
</style>